
    const PI = Number('3.1415926535897932384626')
    const a = 6378245.0
    const ee = Number('0.00669342162296594323')
export default {
  name: 'GoogleDetail',
  props: {
    mapDetail: {
      type: Object,
      default: () => {
        return null
      }
    },
    isShowMap: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    dataPointList: {
      type: Array,
      default: () => []
    },
    googlePoint: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      markerPoint: { lng: '', lat: '' },
      icon: { url: '', size: { width: '', height: '' } },
      zoom: 1,
      img: '',
      isFlow: false,
      map: null,
      infowindow: null,
      marker: null,
      dataInfo: {} // 数据
    }
  },
  watch: {
    isShowMap(oldv) {
      if (oldv) {
        this.loadGoogleMap(this.googlePoint)
      }
    }
  },
  created() {
  },
   mounted() {
    this.initData()
    setTimeout(() => {
      this.loadGoogleMap(this.googlePoint)
    }, 0)
  },
  methods: {
    initData () {
       const mapbaiduurl = {
          position: []
      }
      this.dataPointList.forEach((item) => {
          item.google = this.wgs84togcj02(item.longitude, item.latitude)
          console.log(item);
          mapbaiduurl.position.push({
              x: {
                  lat: item.google[0] + '',
                  lng: item.google[1] + '',
              },
              p: item.pingText,
              v: item.velocity,
              s: item.softwareType
          })
      })
      this.dataInfo = mapbaiduurl
    },
    back() {
      this.map.setZoom(this.zoom)
      this.infowindow.close(this.map, this.marker)
      this.map.panTo(this.marker.getPosition())
      setTimeout(() => {
        this.infowindow.open(this.map, this.marker)
      }, 1300)
    },
    isArDate(str) {
      if (this.$store.state.LanguageCode == 'ar') {
        str = str.split('-').reverse().join('-')
      }
      return str
    },
    pingIcon(i) {
          if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
          else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
          else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
          else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
      },
    /* eslint-disable */ 
     loadGoogleMap(data) {
                console.log('data: ', data);
                const script = document.createElement('script')
                // const key ='AIzaSyBdcQFTH4XHQs_U67iGJdf_SoHlIM6EZKo' //test 测试key111
                let key = "AIzaSyDQsHZefM8bTUX6tcm0Qsfrm7V9O9TPc9A"
                if (window.location.hostname == 'localhost') {
                    key = 'AIzaSyBdcQFTH4XHQs_U67iGJdf_SoHlIM6EZKo' //test 测试key111
                }
                script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap&language=${this.$store.state.LanguageCode}`
                script.defer = true
                let that = this
                window.initMap = () => {
                    window.hasGoogleMap = true
                    const map = new google.maps.Map(document.getElementById('googleMap'), {
                        center: data,
                        clickableIcons: false, //禁止点击,
                        zoom: this.zoom,
                        maxZoom:15,
                        minZoom:5,
                        zoomControl: false, //放大缩小
                        rotateControl: false,//旋转
                        streetViewControl: false, //小人
                        fullscreenControl: false, //全屏
                        InfoWindowOpenOptions:false,
                        gestureHandling: 'greedy', //屏蔽ctrl
                        mapTypeControl: false,
                        scaleControl: false,
                    })
                    that.map = map;
                    const { lat, lng } = data
                    console.log('this.dataInfo', this.dataInfo);
                    this.dataInfo.position.forEach((item) => {
    //                     const marker = new google.maps.Marker({
                            //   position,
                            //   map,
                            //   title: `${i + 1}. ${title}`,
                            //   label: `${i + 1}`,
                            //   optimized: false,
                            // });
                        const marker = new google.maps.Marker({
                            // position: data,
                            position: {
                                lat: Number(item.x.lat),
                                lng: Number(item.x.lng)
                            },
                            map: that.map,
                            //   title: `${1}. ${123}`,
                            //   label: `${1}`,
                            icon: {
                                url: 'https://resources1.interface003.com/appuni/images/yellow.gif',
                                scaledSize: new google.maps.Size(0, 0),
                                // size: new google.maps.Size(90, 90),
                                // origin: new google.maps.Point(0,0),
                                anchor: new google.maps.Point(0, 0),
                            },
                            // optimized: false,
                        })
                        // this.marker = marker
                        const contentString = `<div class="baiduMap mt-sample"
                            >
                            <div id="mapBox" ref="mapBox" class="map-box">
                                <div class="ping-mt" style="{'background-color': ${item.s == 1 ? '#7FC9A8' : item.s == 2 ? '#E48989' : '#E48989'}}">${item.s == 1 ? 'MT4' : item.s == 2 ? 'MT5' : 'MT5'}</div>
                            </div>
                            <div class="ping-b">${item.p} <img class="ping-icon" src="${this.pingIcon(item.v)}" alt=""></div>
                        </div>`
                        const infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                position: {
                                    lat: Number(item.x.lat),
                                    lng: Number(item.x.lng)
                                },
                                pixelOffset:data,
                                disableAutoPan: false,
                                pixelOffset: new google.maps.Size(25, 40),
                            })
                            // this.infowindow = infowindow
                            // marker.setIcon(marker);
                            infowindow.open(map, null,false); // infowindow直接打开
                        })
                    setTimeout(()=>{
                        that.map.setCenter(new google.maps.LatLng(lat,lng))
                    },500)
                }
                if (!window.hasGoogleMap) {
                    document.head.appendChild(script)
                } else {
                    window.initMap()
                }


            },
    wgs84togcj02(lng, lat) { // WGS-84 转 GCJ-02
                const _lat = +lat
                const _lng = +lng

                // if (!(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)) {
                // 	console.log('是在国内');
                // 	return [lng, lat]
                // } else {
                let dlat = this.transformlat(_lng - 105.0, _lat - 35.0)
                let dlng = this.transformlng(_lng - 105.0, _lat - 35.0)
                const radlat = (_lat / 180.0) * PI
                let magic = Math.sin(radlat)
                magic = 1 - ee * magic * magic
                const sqrtmagic = Math.sqrt(magic)
                dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
                dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
                const mglat = _lat + dlat
                const mglng = _lng + dlng
                return [mglng, mglat]
                // }
            },
     transformlat(lng, lat) {
                const _lat = +lat
                const _lng = +lng
                let ret = -100.0 + 2.0 * _lng + 3.0 * _lat + 0.2 * _lat * _lat + 0.1 * _lng * _lat + 0.2 * Math.sqrt(Math.abs(_lng))
                ret += ((20.0 * Math.sin(6.0 * _lng * PI) + 20.0 * Math.sin(2.0 * _lng * PI)) * 2.0) / 3.0
                ret += ((20.0 * Math.sin(_lat * PI) + 40.0 * Math.sin((_lat / 3.0) * PI)) * 2.0) / 3.0
                ret += ((160.0 * Math.sin((_lat / 12.0) * PI) + 320 * Math.sin((_lat * PI) / 30.0)) * 2.0) / 3.0
                return ret
            },
            transformlng(lng, lat) {
                const _lat = +lat
                const _lng = +lng
                let ret = 300.0 + _lng + 2.0 * _lat + 0.1 * _lng * _lng + 0.1 * _lng * _lat + 0.1 * Math.sqrt(Math.abs(lng))
                ret += ((20.0 * Math.sin(6.0 * _lng * PI) + 20.0 * Math.sin(2.0 * _lng * PI)) * 2.0) / 3.0
                ret += ((20.0 * Math.sin(_lng * PI) + 40.0 * Math.sin((_lng / 3.0) * PI)) * 2.0) / 3.0
                ret += ((150.0 * Math.sin((_lng / 12.0) * PI) + 300.0 * Math.sin((_lng / 30.0) * PI)) * 2.0) / 3.0
                return ret
            }
  }
}
